import { render, staticRenderFns } from "./ModalVideoUpload.vue?vue&type=template&id=4d2e2a81&"
import script from "./ModalVideoUpload.vue?vue&type=script&lang=js&"
export * from "./ModalVideoUpload.vue?vue&type=script&lang=js&"
import style0 from "./ModalVideoUpload.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../code/tibava/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports